import { createFileRoute } from '@tanstack/react-router'

import { PageCard, PageLayout } from '@/components/ui/page'

import { SupplierFormCreate } from '@/features/outlet/components/outlet-supplier-form'

export const Route = createFileRoute('/_app/inventory/supplier/create')({
	component: RouteComponent,
})

function RouteComponent() {
	return (
		<PageLayout.Root>
			<PageLayout.Header
				breadcrumbs={[
					['/inventory', 'Inventory'],
					['/inventory/supplier', 'Supplier'],
					[Route.fullPath, 'Tambah supplier'],
				]}
			/>
			<PageCard.Root>
				<PageCard.Header title="Buat supplier" />
				<SupplierFormCreate />
			</PageCard.Root>
		</PageLayout.Root>
	)
}
